import * as React from "react";

const State = () => {
  return (
    <ol className="references">
      <li>
        Centers for Disease Control and Prevention. MMWR Weekly:{" "}
        <i>pneumocystis</i> pneumonia—Los Angeles.{" "}
        <i>MMWR Morb Mortal Wkly Rep.</i> 1981;30(21):1-3. Accessed May 7, 2024.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/mmwr/preview/mmwrhtml/june_5.htm"
        >
          https://www.cdc.gov/mmwr/preview/mmwrhtml/june_5.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Update: mortality
        attributable to HIV infection among people aged 25-44 Years—United
        States, 1991 and 1992. <i>MMWR Morb Mortal Wkly Rep.</i>{" "}
        1993;42(45):869-872. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/mmwr/preview/mmwrhtml/00022174.htm"
        >
          https://www.cdc.gov/mmwr/preview/mmwrhtml/00022174.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. CDC fact sheet: proven HIV
        prevention methods. May 2016. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/nchhstp/newsroom/docs/factsheets/hiv-proven-prevention-methods-508.pdf"
        >
          https://www.cdc.gov/nchhstp/newsroom/docs/factsheets/hiv-proven-prevention-methods-508.pdf
        </a>
      </li>
      <li>
        KFF. The HIV AIDS epidemic in the US: the basics.
        June 7, 2021. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/"
        >
          https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/
        </a>
      </li>
      <li>
        National Institute of Allergy and Infectious Diseases. HIV cure. Updated
        March 26, 2019. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research"
        >
          https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. CDC fact sheet: HIV in the
        United States and Dependent Areas. July 2021. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/statistics/overview/cdc-hiv-us-ataglance.pdf"
        >
          https://www.cdc.gov/hiv/pdf/statistics/overview/cdc-hiv-us-ataglance.pdf
        </a>
      </li>
      <li>
        Huang YA, Zhu W, Smith DK, Harris N, Hoover KW. HIV preexposure
        prophylaxis, by race and ethnicity—United States, 2014&ndash;2016.{" "}
        <i>MMWR Morb Mortal Wkly Rep.</i> 2018;67(41):1147-1150.
      </li>
      <li>
        Centers for Disease Control and Prevention. Estimated annual number of
        HIV infections—United States, 1981–2019.{" "}
        <i>MMWR Morb Mortal Wkly Rep.</i> 2021;70:801-806.
      </li>
      <li>
        HIV.gov. U.S. statistics. Updated December 7, 2023. Accessed February 7,
        2024.{" "}
        <a
          target="_blank"
          href="https://www.hiv.gov/hiv-basics/overview/data-and-trends/statistics/"
        >
          https://www.hiv.gov/hiv-basics/overview/data-and-trends/statistics/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV Mortality 2021. Updated
        May 31, 2023. Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/slidesets/cdc-hiv-surveillance-slideset-mortality-2021.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/slidesets/cdc-hiv-surveillance-slideset-mortality-2021.pdf
        </a>
      </li>
      
      <li>
        Centers for Disease Control and Prevention. HIV declines among young
        people and drives overall decrease in new infections. Updated May 23,
        2023. Accessed February 7, 2024.{" "}
        <a
          target="_blank"
          href="https://www.cdc.gov/nchhstp/newsroom/2023/2021-hiv-incidence.html"
        >
          https://www.cdc.gov/nchhstp/newsroom/2023/2021-hiv-incidence.html
        </a>
      </li>
      <li>
        118th Congress (2023-2024). H.R.4392 - PrEP access and coverage act of
        2023. Updated August 8, 2023. Accessed February 9, 2024.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.congress.gov/bill/118th-congress/house-bill/4392/text"
        >
          https://www.congress.gov/bill/118th-congress/house-bill/4392/text
        </a>
      </li>
      <li>
         KFF. Disparities in health and health care: 5 key
        questions and answers. April 21, 2023. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/racial-equity-and-health-policy/issue-brief/disparities-in-health-and-health-care-5-key-question-and-answers/"
        >
          https://www.kff.org/racial-equity-and-health-policy/issue-brief/disparities-in-health-and-health-care-5-key-question-and-answers/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the United States by
        race and ethnicity: Viral suppression and barriers to care. Updated June
        26, 2023. Accessed February 8, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/racialethnic/other-races/viral-suppression.html"
        >
          https://www.cdc.gov/hiv/group/racialethnic/other-races/viral-suppression.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV treatment. Updated November 21, 2023. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html"
        >
          https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and all gay and bisexual
        men. Updated February 16, 2023. Accessed May 7, 2024.
        <br />
        <a target="_blank" href="https://www.cdc.gov/hiv/group/msm/index.html">
          https://www.cdc.gov/hiv/group/msm/index.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Men who have sex with men
        (MSM). Updated July 21, 2021. Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/std/treatment-guidelines/msm.htm"
        >
          https://www.cdc.gov/std/treatment-guidelines/msm.htm
        </a>
      </li>
      <li>
        HIV.gov. Impact on racial and ethnic minorities. Updated December 18,
        2023. Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.hiv.gov/hiv-basics/overview/data-and-trends/impact-on-racial-and-ethnic-minorities/ "
        >
          https://www.hiv.gov/hiv-basics/overview/data-and-trends/impact-on-racial-and-ethnic-minorities/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Fast Facts: HIV and Gay and Bisexual Men. Reviewed October 7, 2024. Accessed October 17, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/data-research/facts-stats/gay-bisexual-men.html"
        >
          https://www.cdc.gov/hiv/data-research/facts-stats/gay-bisexual-men.html 
        </a>
      </li>
      <li>
        AIDSVu. National gay men’s HIV/AIDS awareness day 2021. Updated
        September 27, 2021. Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://aidsvu.org/national-gay-mens-hiv-aids-awarness-day-2021/ "
        >
          https://aidsvu.org/national-gay-mens-hiv-aids-awarness-day-2021/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Estimated HIV incidence and
        prevalence in the United States, 2017–2021: Special focus profiles.{" "}
        <i>HIV Surveillance Supplemental Report</i>. 2023;28(3). Updated May 23,
        2023. Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-28-no-3/content/special-focus-profiles.html"
        >
          https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-28-no-3/content/special-focus-profiles.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Estimated HIV incidence and
        prevalence in the United States, 2017–2021: National profile.{" "}
        <i>HIV Surveillance Supplemental Report</i>. 2023;28(3). Updated May 23,
        2023. Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-28-no-3/content/national-profile.html"
        >
          https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-28-no-3/content/national-profile.html
        </a>
      </li>
      


      <li>
      Centers for Disease Control and Prevention. NCHHSTP AtlasPlus. 
        <br />
        <a
          target="_blank"
          href="https://gis.cdc.gov/grasp/nchhstpatlas/main.html"
        >
           https://gis.cdc.gov/grasp/nchhstpatlas/main.html
        </a>.
        Accessed September 17, 2024.
      </li>


      <li>
        Centers for Disease Control and Prevention. Estimated HIV incidence and
        prevalence in the United States, 2015–2019.{" "}
        <i>HIV Surveillance Supplemental Report</i>. 2021;26(No. 1). Published
        May 2021. Accessed February 8, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf
        </a>
      </li>

      <li>
      Centers for Disease Control and Prevention. Monitoring selected national HIV prevention and care objectives by using HIV surveillance data&mdash;United States and 6 territories and freely associated states, 2022. HIV Surveillance Supplemental Report 2024;29(No. 2).
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv-data/nhss/national-hiv-prevention-and-care-outcomes.html"
        >
           https://www.cdc.gov/hiv-data/nhss/national-hiv-prevention-and-care-outcomes.html
        </a>.
        Published May 2024. Accessed September 17, 2024.
      </li>


      <li>
        Be in the KNOW. HIV and transgender people. Updated March 30, 2023. Accessed
        May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.beintheknow.org/understanding-hiv-epidemic/community/hiv-and-transgender-people"
        >
          https://www.beintheknow.org/understanding-hiv-epidemic/community/hiv-and-transgender-people
        </a>
      </li>
      <li>
        Human Rights Campaign. Transgender people and HIV: what we know.
        Published 2020. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.hrc.org/resources/transgender-people-and-hiv-what-we-know"
        >
          https://www.hrc.org/resources/transgender-people-and-hiv-what-we-know
        </a>
      </li>
      <li>
        James SE, Herman JL, Rankin S, et al. The report of the 2015 U.S.
        Transgender Survey. National Center for Transgender Equality. Published
        December 2017. Accessed May 7, 2024.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://transequality.org/sites/default/files/docs/usts/USTS-Full-Report-Dec17.pdf"
        >
          https://transequality.org/sites/default/files/docs/usts/USTS-Full-Report-Dec17.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV infection, risk,
        prevention, and testing behaviors among transgender women—National HIV
        Behavioral Surveillance, 7 U.S. Cities, 2019–2020.{" "}
        <i>HIV Surveillance Special Report.</i> 2021;27. Published April 2021.
        Accessed May 7, 2024.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-27.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-27.pdf
        </a>
      </li>
      <li>
        Stutterheim SE, van Dijk M, Wang H, Jonas KJ. The worldwide burden of
        HIV in transgender individuals: An updated systematic review and
        meta-analysis. <em>PLoS One</em>. 2021;16(12):e0260063.
      </li>
      <li>
        AIDSVu. Local data: United States. Accessed February 8, 2024.{" "}
        <a target="_blank" href="https://aidsvu.org/local-data/united-states/">
          https://aidsvu.org/local-data/united-states/
        </a>
      </li>
      <li>
        Diallo DD. The Sankofa paradox: Why black women know the HIV epidemic
        ends with "WE". <i>Am J Public Health</i>. 2021;111(7):1237-1239.
        <br />
      </li>
      <li>
        Be in the KNOW. HIV and women. Updated March 30, 2023. Accessed
        May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.beintheknow.org/understanding-hiv-epidemic/community/hiv-and-women"
        >
          https://www.beintheknow.org/understanding-hiv-epidemic/community/hiv-and-women
        </a>
      </li>
      <li>
        Higgins JA, Hoffman S, Dworkin SL. Rethinking gender, heterosexual men,
        and women’s vulnerability to HIV/AIDS. <em>Am J Public Health.</em>{" "}
        2010;100(3):435-445.
      </li>
      <li>
        KFF. Women and HIV in the United States. March 9,
        2020. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/hivaids/fact-sheet/women-and-hivaids-in-the-united-states/"
        >
          https://www.kff.org/hivaids/fact-sheet/women-and-hivaids-in-the-united-states/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Diagnoses of HIV infection
        in the United States and dependent areas 2021: Special focus profiles.{" "}
        <i>HIV Surveillance Report</i>. 2023;34. Updated May 23, 2023. Accessed
        February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-34/content/special-focus-profiles.html"
        >
          https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-34/content/special-focus-profiles.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV Testing and Youth. Updated March 26, 2024. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/healthyyouth/youth_hiv/hiv-information-and-youth.htm"
        >
          https://www.cdc.gov/healthyyouth/youth_hiv/hiv-information-and-youth.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the United States by Age. Updated October 2, 2023. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/age/index.html"
        >
          https://www.cdc.gov/hiv/group/age/index.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Adolescents and young
        adults. Updated April 8, 2021. Accessed February 8, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/std/life-stages-populations/adolescents-youngadults.htm"
        >
          https://www.cdc.gov/std/life-stages-populations/adolescents-youngadults.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. STDs and HIV – CDC fact
        sheet. Updated April 12, 2022. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/std/hiv/stdfact-std-hiv.htm"
        >
          https://www.cdc.gov/std/hiv/stdfact-std-hiv.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. CDC Fact Sheet: Information for Teens and Young Adults: Staying Healthy and Preventing STDs. Updated April 12, 2022. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/std/life-stages-populations/stdfact-teens.htm"
        >
          https://www.cdc.gov/std/life-stages-populations/stdfact-teens.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Estimated HIV incidence and
        prevalence in the United States, 2017–2021.{" "}
        <i>HIV Surveillance Report</i>. 2023;28(3). Updated May 23, 2023.
        Accessed February 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-28-no-3/index.html"
        >
          https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-28-no-3/index.html
        </a>
      </li>
      
      <li>
        Centers for Disease Control and Prevention. HIV in the United States by
        age: Knowledge of status. Updated October 2, 2023. Accessed February 8,
        2024.{" "}
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/age/status-knowledge.html"
        >
          https://www.cdc.gov/hiv/group/age/status-knowledge.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the United States by
        age: Viral suppression. Updated October 2, 2023. Accessed February 8,
        2024.{" "}
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/age/viral-suppression.html"
        >
          https://www.cdc.gov/hiv/group/age/viral-suppression.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the United States by
        age: PrEP coverage. Updated October 19, 2023. Accessed February 8, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/age/prep-coverage.html"
        >
          https://www.cdc.gov/hiv/group/age/prep-coverage.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the southern United
        States. Published September 2019. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf"
        >
          https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf
        </a>
      </li>
      <li>
        Reif S, Safley D, McAllaster C, Wilson E, Whetten K. State of HIV in the
        US deep south. <i>J Community Health.</i> 2017;42(5):844-853.
      </li>
      <li>
        AIDSVu. Deeper look: HIV in the South. Accessed February 8, 2024.{" "}
        <a
          target="_blank"
          href="https://aidsvu.org/resources/deeper-look-south/"
        >
          https://aidsvu.org/resources/deeper-look-south/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Diagnoses of HIV infection
        in the United States and dependent areas 2021: National profile.{" "}
        <i>HIV Surveillance Report</i>. 2023;34. Updated May 23, 2023. Accessed
        February 8, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-34/content/national-profile.html"
        >
          https://www.cdc.gov/hiv/library/reports/hiv-surveillance/vol-34/content/national-profile.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Diagnoses of HIV infection
        in the United States and dependent areas, 2017.{" "}
        <i>HIV Surveillance Report.</i> 2017;29. Published November 2018.
        Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2017-vol-29.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2017-vol-29.pdf
        </a>
      </li>

      <li>
        Centers for Disease Control and Prevention. Diagnoses of HIV infection
        in the United States and dependent areas, 2019.{" "}
        <i>HIV Surveillance Report</i>. 2019;32. Published May 2021. Accessed
        February 8, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2018-updated-vol-32.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2018-updated-vol-32.pdf
        </a>
      </li>
      
      <li>
        Centers for Disease Control and Prevention. Estimated HIV incidence and
        prevalence in the United States, 2015–2019.{" "}
        <i>HIV Surveillance Supplemental Report</i>. 2021;26(1). Published May
        2021. Accessed February 17, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf
        </a>
      </li>

      <li>
        AIDSVu.org. Regional Data: South. Accessed May 7, 2024.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://aidsvu.org/local-data/united-states/south/"
        >
          https://aidsvu.org/local-data/united-states/south/
        </a>
      </li>
      <li>
        National Institute of Allergy and Infectious Diseases. HIV/AIDS. Updated
        June 29, 2020. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.niaid.nih.gov/diseases-conditions/hivaids"
        >
          https://www.niaid.nih.gov/diseases-conditions/hivaids
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Monitoring selected national
        HIV prevention and care objectives by using surveillance data—United
        States and 6 dependent areas, 2019.{" "}
        <i>HIV Surveillance Supplemental Report</i>. 2021;26(2). Published May
        2021. Accessed May 7, 2024.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-vol-26-no-2.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-vol-26-no-2.pdf
        </a>
      </li>
    </ol>
  );
};

export default State;
